{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "operate",
  "features": [
    {
      "id": "maintenance-program",
      "name": "Maintenance Program",
      "summary": "Requirements, intervals, and revisions.",
      "availability": "AVAILABLE"
    },
    {
      "id": "due-forecast",
      "name": "Due & Forecast",
      "summary": "What's due and when, by hours, cycles, and calendar.",
      "availability": "AVAILABLE"
    },
    {
      "id": "readiness",
      "name": "Aircraft Readiness",
      "summary": "Status, blockers, and evidence.",
      "availability": "AVAILABLE"
    },
    {
      "id": "ad-sb-llp",
      "name": "AD / SB / LLP",
      "summary": "Applicability evidence and component life status.",
      "availability": "AVAILABLE"
    },
    {
      "id": "mel-deferrals",
      "name": "MEL & Deferrals",
      "summary": "Deferred items and expirations.",
      "availability": "AVAILABLE"
    },
    {
      "id": "records-stewardship",
      "name": "Records Stewardship",
      "summary": "Accept and organize returned records.",
      "availability": "AVAILABLE"
    },
    {
      "id": "mx-control-handoff",
      "name": "Maintenance Control Handoff",
      "summary": "Event continuity across duty periods.",
      "availability": "AVAILABLE"
    },
    {
      "id": "compliance-iq",
      "name": "complianceIQ",
      "summary": "AI-assisted compliance context.",
      "availability": "AVAILABLE"
    }
  ]
}